document.addEventListener('DOMContentLoaded', function() {
  const outer = document.getElementById('outer-ring-text');
  const inner = document.getElementById('inner-ring-text');
  const preview = document.getElementById('live-preview');

  const fontMap = {
    "Inter": "Inter, sans-serif",
    "Bodoni Moda": "Bodoni Moda, serif",
    "Great Vibes": "Great Vibes, cursive",
    "Fuzzy Bubbles": "Fuzzy Bubbles, cursive",
    "Raleway": "Raleway, sans-serif"
  };

  function updatePreview() {
    const outerText = outer ? outer.value.trim() : "";
    const innerText = inner ? inner.value.trim() : "";

    if (outerText && innerText) {
      preview.innerHTML = `${outerText}<br><span style="font-size: 0.78em; opacity: 0.9;">${innerText}</span>`;
    } else if (outerText) {
      preview.textContent = outerText;
    } else if (innerText) {
      preview.textContent = innerText;
    } else {
      preview.textContent = "Your text will appear here";
    }
  }

  function applyFont() {
    let selected = "";
    const select = document.querySelector('select[name="id"]');
    if (select) {
      selected = select.options[select.selectedIndex].text;
    } else {
      const checked = document.querySelector('input[name="id"]:checked');
      if (checked) {
        const label = document.querySelector(`label[for="${checked.id}"]`);
        selected = label ? label.textContent.trim() : "";
      }
    }

    Object.keys(fontMap).forEach(name => {
      if (selected.includes(name)) {
        preview.style.fontFamily = fontMap[name];
      }
    });
  }

  // Attach listeners
  if (outer) outer.addEventListener('input', updatePreview);
  if (inner) inner.addEventListener('input', updatePreview);

  document.addEventListener('change', (e) => {
    if (e.target.name === 'id') {
      setTimeout(() => { applyFont(); updatePreview(); }, 100);
    }
  });

  // Run on load
  setTimeout(() => { applyFont(); updatePreview(); }, 1200);
});